module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_01_sp-2d3410a85c6a1b3495c7c95d45923396.png";